import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UIHelpers {
  checkErrors(fc: any, form: any): boolean {
    return fc.invalid && (fc.touched || fc.dirty || form.submitted);
  }
}
